import { Component, Inject, OnInit, PLATFORM_ID, ViewChild, ViewEncapsulation } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { ActivatedRoute } from '@angular/router'
import { SEOService, SharedService } from '@flowaccount/landing'
import { TaxInvoiceTab } from '../../../../enum/landing-enum';
import { TranslateService } from '@ngx-translate/core'
import { SwiperDirective } from 'ngx-swiper-wrapper'

@Component({
  selector: 'flowaccount-tax-invoice-form',
  templateUrl: './tax-invoice-form.component.html',
  styleUrls: ['./tax-invoice-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TaxInvoiceFormComponent implements OnInit {
  @ViewChild(SwiperDirective, { static: true }) directiveRef?: SwiperDirective
  public config: any
  public index: any

  public configMobile: any
  public indexMobile: any

  public taxInvoiceTabEnum = TaxInvoiceTab
  public showFormPattern = this.taxInvoiceTabEnum.FullTaxInvoice

  constructor(
    public translate: TranslateService,
    public sharedService: SharedService,
    protected titleService: Title,
    protected seoService: SEOService,
  ) {}

  ngOnInit(): void {
    this.config = {
      init: true,
      direction: 'horizontal',
      slidesPerView: 'auto',
      autoplay: {
        delay: 7000,
        stopOnLastSlide: true,
        disableOnInteraction: true,
        reverseDirection: false,
        waitForTransition: true,
      },
      pagination: {
        el: '.swiper-pagination-ss-desktop',
        clickable: true,
        hideOnClick: false,
      },
    }

    this.configMobile = {
      init: true,
      direction: 'horizontal',
      slidesPerView: 'auto',
      autoplay: {
        delay: 7000,
        stopOnLastSlide: true,
        disableOnInteraction: true,
        reverseDirection: false,
        waitForTransition: true,
      },
      pagination: {
        el: '.swiper-pagination-ss-desktop.mobile',
        clickable: true,
        hideOnClick: false,
      },
    }
  }

  displayFormFormat(index: number) {
    return (this.showFormPattern = index)
  }
}
